<template>
  <b-card>
    <div class="notification-list">
      <b-list-group v-if="userNotificationsList.length > 0">
        <b-list-group-item v-for="(item, i) in userNotificationsList" :key="i" :href="item.link" @click="clickedNotif(item)" :variant="item.isNew ? 'info': ''">
            {{ item.message }} <br/>
          <span class="notification-time"><i class="fa"></i> {{ item.timeSpan }}</span>
        </b-list-group-item>
      </b-list-group>
      <b-list-group v-else>
        <b-list-group-item variant="light">
          No notifications to show
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
  
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  computed: {
    ...mapGetters('notification', ['userNotificationsList']),
  },
  methods: {
    ...mapActions('notification', ['getUserNotificationsList', 'updateUserNotification']),
    clickedNotif(e) {
      if (e.isNew) {
        this.updateUserNotification({ ...e, isNew: false });
      }
    }
  },
  mounted() {
    this.getUserNotificationsList();
  }
}
</script>

<style>
.notification-count {
  position: absolute !important;
  top: -5px;
  font-size: small
}
.notification-text {
  white-space: normal !important; 
  word-wrap: break-word; 
  min-width: 160px;
  max-width: 500px;
}
.notification-time {
  font-style: italic;
  font-size: smaller
}
</style>